export const MAINTENANCE = '/maintenance'
export const SIGN_UP_ADVERTISER = '/sign-up/advertiser'
export const SIGN_UP_PASSWORD = '/sign-up/password/:email/:role/:token'
export const SIGN_UP_PASSWORD_TAIL = '/sign-up/password/:email/:role/:token/:tail'
export const RESET_PASSWORD = '/reset-password'
export const NEW_PASSWORD = '/reset-password/new-password/:email/:role/:token'
export const NEW_PASSWORD_TAIL = '/reset-password/new-password/:email/:role/:token/:tail'
export const BILLING_HISTORY = '/billing'
